import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FeatureFlagService, ffKeys } from '@app/@shared/services/featureflag.service';

@UntilDestroy()
@Component({
    selector: 'app-promo-banner',
    templateUrl: './app-promo-banner.component.html',
    styleUrls: ['./app-promo-banner.component.scss'],
    standalone: false
})
export class AppPromoBannerComponent implements OnInit {
  shouldShowBanner = false;
  private readonly STORAGE_KEY = 'app_promo_banner_dismissed_at';
  private readonly DISMISSAL_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  constructor(
    private readonly router: Router,
    private readonly featureFlag: FeatureFlagService
  ) {}

  ngOnInit(): void {
    this.featureFlag.getFlag(ffKeys.mobileAppPromotionBanner)
      .pipe(untilDestroyed(this))
      .subscribe(isEnabled => {
        if (isEnabled) {
          this.checkDismissalState();
        } else {
          this.shouldShowBanner = false;
        }
      });
  }

  dismissBanner(): void {
    this.shouldShowBanner = false;
    localStorage.setItem(this.STORAGE_KEY, Date.now().toString());
  }

  openApp(): void {
    const userAgent = navigator.userAgent;
    const currentPath = this.router.url.replace(/^\//, '');
    const fallbackAndroid = 'https://play.google.com/store/apps/details?id=com.techinsights';
    const fallbackIOS = 'https://apps.apple.com/us/app/techinsights/id1564944610';

    if (/android/i.test(userAgent)) {
      window.location.href = `intent://library.techinsights.com/${currentPath}#Intent;scheme=https;package=com.techinsights;S.browser_fallback_url=${encodeURIComponent(fallbackAndroid)};end`;
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      const appUrl = `techinsights://${currentPath}`;
      const now = Date.now();
      window.location.href = appUrl;
      setTimeout(() => {
        if (Date.now() - now < 3000) {
          window.location.href = fallbackIOS;
        }
      }, 2500);
    } else {
      window.location.href = fallbackAndroid;
    }
  }

  private checkDismissalState(): void {
    const lastDismissedAt = localStorage.getItem(this.STORAGE_KEY);

    if (!lastDismissedAt) {
      this.shouldShowBanner = true;
      return;
    }

    const dismissalTime = parseInt(lastDismissedAt, 10);
    const expirationTime = dismissalTime + this.DISMISSAL_DURATION;

    this.shouldShowBanner = Date.now() > expirationTime;
  }
}